// API Base URL - uses env variable for production, empty for local dev with proxy
export const API_BASE_URL = import.meta.env.VITE_API_URL || ''

// Lead Statuses
export const LEAD_STATUSES = [
  { value: 'new', label: 'New', color: 'bg-blue-100 text-blue-800' },
  { value: 'contacted', label: 'Contacted', color: 'bg-yellow-100 text-yellow-800' },
  { value: 'qualified', label: 'Qualified', color: 'bg-green-100 text-green-800' },
  { value: 'unqualified', label: 'Unqualified', color: 'bg-gray-100 text-gray-800' },
  { value: 'converted', label: 'Converted', color: 'bg-purple-100 text-purple-800' },
  { value: 'lost', label: 'Lost', color: 'bg-red-100 text-red-800' },
] as const

// Qualification Statuses
export const QUALIFICATION_STATUSES = [
  { value: 'pending', label: 'Pending', color: 'bg-gray-100 text-gray-800' },
  { value: 'in_progress', label: 'In Progress', color: 'bg-blue-100 text-blue-800' },
  { value: 'qualified', label: 'Qualified', color: 'bg-green-100 text-green-800' },
  { value: 'disqualified', label: 'Disqualified', color: 'bg-red-100 text-red-800' },
] as const

// Conversation Types
export const CONVERSATION_TYPES = [
  { value: 'email', label: 'Email', icon: 'Mail' },
  { value: 'outbound_call', label: 'Outbound Call', icon: 'PhoneOutgoing' },
  { value: 'inbound_call', label: 'Inbound Call', icon: 'PhoneIncoming' },
  { value: 'advisor', label: 'Advisor Chat', icon: 'MessageSquare' },
] as const

// Sentiment Values
export const SENTIMENTS = [
  { value: 'positive', label: 'Positive', color: 'bg-green-100 text-green-800' },
  { value: 'neutral', label: 'Neutral', color: 'bg-gray-100 text-gray-800' },
  { value: 'negative', label: 'Negative', color: 'bg-red-100 text-red-800' },
] as const

// Voice Options (Bland.ai)
export const VOICE_OPTIONS = [
  { value: 'maya', label: 'Maya (Female)' },
  { value: 'matt', label: 'Matt (Male)' },
  { value: 'tina', label: 'Tina (Female)' },
  { value: 'evelyn', label: 'Evelyn (Female)' },
] as const

// Model Options (Bland.ai)
export const MODEL_OPTIONS = [
  { value: 'base', label: 'Base' },
  { value: 'enhanced', label: 'Enhanced' },
  { value: 'turbo', label: 'Turbo' },
] as const

// Language Options
export const LANGUAGE_OPTIONS = [
  { value: 'en', label: 'English' },
  { value: 'es', label: 'Spanish' },
  { value: 'fr', label: 'French' },
  { value: 'babel', label: 'Auto-Detect (Babel)' },
] as const

// User Roles
export const USER_ROLES = [
  { value: 'admin', label: 'Administrator', color: 'bg-purple-100 text-purple-800' },
  { value: 'standard', label: 'Standard User', color: 'bg-blue-100 text-blue-800' },
] as const

// Knowledge Base Categories
export const KB_CATEGORIES = [
  'Pricing',
  'Operations',
  'Sales',
  'Support',
  'Technical',
  'Legal',
  'Company',
  'Products',
  'Services',
  'FAQ',
  'Policies',
  'Training',
  'Marketing',
  'Compliance',
  'Security',
  'Other',
] as const

// Knowledge Base Content Types
export const KB_CONTENT_TYPES = [
  'FAQ',
  'Policy',
  'Procedure',
  'Script',
  'Template',
  'Case Study',
  'Product Info',
  'Pricing',
  'Objection Handler',
  'Reference',
] as const

// Prompt Types
export const PROMPT_TYPES = [
  { value: 'outbound_call', label: 'Outbound Call' },
  { value: 'inbound_call', label: 'Inbound Call' },
  { value: 'email', label: 'Email' },
  { value: 'qualification', label: 'Qualification' },
  { value: 'advisor', label: 'Advisor' },
] as const

// Pagination Defaults
export const DEFAULT_PAGE_SIZE = 20
export const PAGE_SIZE_OPTIONS = [10, 20, 50, 100] as const

// Date Ranges for Filters
export const DATE_RANGE_OPTIONS = [
  { value: 'today', label: 'Today' },
  { value: '7d', label: 'Last 7 Days' },
  { value: '30d', label: 'Last 30 Days' },
  { value: '90d', label: 'Last 90 Days' },
  { value: 'all', label: 'All Time' },
] as const
